// components/Navbar/Navbar.js
import React from 'react';
import './Navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src="/assets/logo-main-page.png" alt="Zyve Logo" className="logo-img" />
        <h1>Zyve</h1>
      </div>
      <div className="navbar-links">
        <a href="#about">About</a>
        <a href="#services">Services</a>
        <a href="#contact">Contact Us</a>
      </div>
    </nav>
  );
}

export default Navbar;
